import { connectRouter } from 'connected-react-router';
import { History } from 'history';
import { combineReducers } from 'redux-immutable';
import app from 'store/app/reducer';
import ContractReducer from 'store/contract/reducer';
import CredentialsReducer from 'store/credentials/reducer';
import geolocAgentReducer from 'store/geolocAgent/reducer';
import globalReducer from 'store/global/reducer';
import languageReducer from 'store/LanguageProvider/reducer';
import pacReducer from 'store/pac/reducer';
import sinistreReducer from 'store/sinistre/reducer';
import UserReducer from 'store/user/reducer';
import doctors from '../doctors/reducer';
import organizations from '../organizations/reducer';
import policies from '../policies/reducer';

//inject app reducers
const appReducers = (history: History) =>
  combineReducers({
    agent: geolocAgentReducer,
    app,
    contract: ContractReducer,
    doctors,
    intl: languageReducer,
    global: globalReducer,
    organizations,
    pac: pacReducer,
    policies,
    question: CredentialsReducer,
    router: connectRouter(history),
    sinistre: sinistreReducer,
    user: UserReducer,
  });

export default appReducers;
